import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import moment from 'moment-timezone';
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}
export function timeAgo(time) {
  var between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}
export function parseTime(time, cFormat) {
  // console.log("第一个时间"+time);

  if (!time) {
    return "";
  }
  time = time / 1000;
  if (typeof time == "string") {
    time = new Date(time);
  }
  if (arguments.length === 0) {
    return null;
  }
  if ((time + '').length >= 9) {
    time = +time * 1000;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = moment(time);
  // if (typeof time === 'object') {
  //     // date = time
  //     date = moment.tz(time, "Asia/Tokyo");
  // } else {
  //     date = moment.tz(time, "Asia/Tokyo");
  // }
  var formatObj = {
    y: date.get("year"),
    m: date.get("month") + 1,
    d: date.get("date"),
    h: date.get('hour'),
    i: date.get('minute'),
    s: date.get('second'),
    a: date.days()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}
export function formatTime(time, option) {
  time = +time * 1000;
  var d = moment(time).utc(9).toDate();
  var now = moment().utc(9).toDate();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/* 数字 格式化*/
export function nFormatter(num, digits) {
  var si = [{
    value: 1E18,
    symbol: 'E'
  }, {
    value: 1E15,
    symbol: 'P'
  }, {
    value: 1E12,
    symbol: 'T'
  }, {
    value: 1E9,
    symbol: 'G'
  }, {
    value: 1E6,
    symbol: 'M'
  }, {
    value: 1E3,
    symbol: 'k'
  }];
  for (var i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

/* 数字 格式化 保留小数 并且百分比*/
/**
 *
 */
export function numPercentFormatter(num, lodash, digits) {
  return lodash.round(num * 100, digits);
}
export function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

//只是展示用的这个千位分隔符,不是的话用下面那个
export function toThousandslsFilter(num) {
  //	console.log(num)
  if (!isNaN(num) && num != "") {
    return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
      return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
    });
  } else {
    return num;
  }
}
export function moneyNumFormat(value) {
  // if(!value) return '';
  // var intPart = Number(value).toFixed(0); //获取整数部分
  // var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
  //
  // var floatPart = ""; //预定义小数部分
  // var value2Array = (value + "").split(".");
  //
  // //=2表示数据有小数位
  // if(value2Array.length == 2) {
  // 	floatPart = value2Array[1].toString(); //拿到小数部分
  //
  // 	if(floatPart.length == 1) { //补0,实际上用不着
  // 		return intPartFormat + "." + floatPart + '0';
  // 	} else {
  // 		return intPartFormat + "." + floatPart;
  // 	}
  //
  // } else {
  // 	return intPartFormat + floatPart;
  // }
  var num = parseInt((value * 100).toFixed(1)) / 100;
  if (!isNaN(num) && num != "") {
    return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
      return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
    });
  } else {
    return num;
  }
}
export function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
export function moneyFormat(money, type) {
  // 0:四舍五入 1：向上取整 2:向下取整
  if (type == 0) {
    return Math.round(money);
  } else if (type == 1) {
    return Math.ceil(money);
  } else {
    return Math.floor(money);
  }
}
export function keepTwoDecimal(num) {
  var result = parseFloat(num);
  if (isNaN(result)) {
    // alert('传递参数错误，请检查！');
    return false;
  }
  result = Math.round(num * 100) / 100;
  return result;
}